const form = document.getElementById("blog-search__form");
const submitBtn = document.querySelector(".search-bar__btn");
const blogList = document.querySelector(".m-blog__list");
const searchHeadline = document.querySelector(".search-results-headline");
const pagination = document.querySelector(".m-pagination");
const input = document.querySelector("[data-search-input]");
const clearSearch = document.querySelector(".clear-search");
const noResults = document.querySelector(".no-results");

clearSearch.addEventListener("click", () => {
  if (searchHeadline.style.display === "block") {
    location.reload();
  } else {
    input.value = "";
  }
});

input.addEventListener("input", (e) => {
  if (e.target.value == "") {
    clearSearch.classList.remove("clear-search-active");
    return;
  }
  if (clearSearch.classList.contains("clear-search-active")) {
    return;
  }
  clearSearch.classList.add("clear-search-active");
});

if (form) {
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const query = formData.get("q");
    const resource = "article";

    fetch(
      window.Shopify.routes.root +
        `search/suggest.json?q=${query}&resources[type]=${resource}&resources[options][fields]=title,body,tag,author`
    )
      .then((response) => response.json())
      .then((resource) => {
        const articles = resource.resources.results.articles;
        console.log(articles);
        if (articles.length === 0) {
          searchHeadline.style.display = "block";
          noResults.style.display = "block";
          pagination.style.display = "none";
          input.value = "";
          blogList.style.visibility = "hidden";
          return;
        }
        if (noResults && noResults.style.display === "block") {
          noResults.style.display = "none";
        }
        const blog = blogList.children[0];
        console.log(blog);
        const doc = new DOMParser().parseFromString(
          blog.outerHTML,
          "text/html"
        );

        blogList.innerHTML = "";
        if (blogList.style.visibility === "hidden") {
          blogList.removeAttribute("style");
        }
        // blogList.style.visibility = "visible";

        articles.forEach((article, idx) => {
          const mainDiv = doc.querySelector(".m-article-card");
          mainDiv.style.setProperty("--animation-order", String(idx + 1));
          doc.querySelector(".m-article-card__image").href = article.url;
          const img = doc.querySelector(".m-image");
          img.children[0].src = article.image;
          img.children[0].removeAttribute("srcset");
          const tag = article.tags.length > 0 ? article.tags[0] : "";
          const tagSection = doc.querySelector(".m-article-card__tags");
          if (tagSection) {
            tagSection.textContent = tag;
          }

          const date = new Date(article.published_at);
          const formattedDate =
            (date.getMonth() + 1).toString().padStart(2, "0") +
            "/" +
            date.getDate().toString().padStart(2, "0") +
            "/" +
            date.getFullYear();
          doc.querySelector(".m-article-card__date").children[0].textContent =
            formattedDate;
          const articleTitle = doc.querySelector(".m-article-card__title");
          articleTitle.children[0].href = article.url;
          articleTitle.children[0].textContent = article.title;
          const regex = /<p>(.*?)<\/p>/g;
          const summary = Array.from(
            article.summary_html.matchAll(regex),
            (match) => match[1]
          );

          const summaryText =
            summary[0] != undefined ? summary[0].slice(0, 100) : "";
          const excerpt = doc.querySelector(".m-article-card__excerpt");
          if (excerpt) {
            excerpt.innerHTML = summaryText;
          }

          doc.querySelector(".m-article-card__readmore").href = article.url;

          blogList.innerHTML += mainDiv.outerHTML;
        });
        searchHeadline.style.display = "block";
        pagination.style.display = "none";
        input.value = "";
        blogList.scrollBy({
          top: -200,
          behavior: "smooth",
        });
      });
  });
}
